/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ProfileAnalysisResultDto } from './ProfileAnalysisResultDto';
import {
    instanceOfProfileAnalysisResultDto,
    ProfileAnalysisResultDtoFromJSON,
    ProfileAnalysisResultDtoFromJSONTyped,
    ProfileAnalysisResultDtoToJSON,
} from './ProfileAnalysisResultDto';

/**
 * @type AnalysisResultDtoXProfile
 * 
 * @export
 */
export type AnalysisResultDtoXProfile = ProfileAnalysisResultDto;


export function AnalysisResultDtoXProfileFromJSON(json: any): AnalysisResultDtoXProfile {
    return AnalysisResultDtoXProfileFromJSONTyped(json, false);
}

export function AnalysisResultDtoXProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultDtoXProfile {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...ProfileAnalysisResultDtoFromJSONTyped(json, true) };
    return  ProfileAnalysisResultDtoFromJSONTyped(json, true);
}

export function AnalysisResultDtoXProfileToJSON(value?: AnalysisResultDtoXProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfProfileAnalysisResultDto(value)) {
        return ProfileAnalysisResultDtoToJSON(value as ProfileAnalysisResultDto);
    }

    return {};
}

/**
 * Check if a given object implements the AnalysisResultDtoXProfile interface.
 */
export function instanceOfAnalysisResultDtoXProfile(value: any): value is AnalysisResultDtoXProfile {
    if (instanceOfProfileAnalysisResultDto(value)) return true;
    return false;
}

